import { type WrappedInsightShiftVolumeAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import calendarIcon from "../../assets/calendar-wrapped.png";

function DecorativeEllipses() {
  // 4 rounded ellipses radiating from a common center point
  const ellipseStyle = {
    position: "absolute",
    width: "55vw",
    height: "75vh",
    borderRadius: "50%",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    pointerEvents: "none",
    top: "50%",
    left: "50%",
    marginTop: "-37.5vh",
    marginLeft: "-27.5vw",
  } as const;

  return (
    <Box
      position="absolute"
      top="13%"
      left={0}
      width="100%"
      height="100%"
      sx={{ transform: "translate(-30%, -20%)" }}
    >
      <Box sx={{ ...ellipseStyle, transform: "rotate(-15deg)" }} />
      <Box sx={{ ...ellipseStyle, transform: "rotate(30deg)" }} />
      <Box sx={{ ...ellipseStyle, transform: "rotate(75deg)" }} />
      <Box sx={{ ...ellipseStyle, transform: "rotate(-60deg)" }} />
    </Box>
  );
}

interface ShiftVolumeContentProps {
  attributes: WrappedInsightShiftVolumeAttributes;
}

export function ShiftVolumeContent(props: ShiftVolumeContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      <DecorativeEllipses />
      {/* Calendar - positioned based on Figma: top 39.7%, left 18.9%, rotated -6.41deg */}
      <Box
        position="absolute"
        sx={{
          top: "30%",
          right: 0,
          zIndex: 0,
        }}
      >
        <Image
          src={calendarIcon}
          alt="Calendar"
          width={292}
          height={292}
          sx={{ transform: "rotate(8.41deg)" }}
        />
      </Box>

      {/* Text section - bottom left, based on Figma: left 7.7%, bottom 10.2% */}
      <Stack
        position="absolute"
        sx={{
          bottom: "12.2%",
          left: "7.7%",
          zIndex: 1,
        }}
        gap={1}
      >
        <Text variant="body1" color="white">
          You worked
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "4.5rem", lineHeight: 1 }}>
          {attributes.shifts}
        </Text>
        <Text variant="body1" color="white">
          shifts in 2025.
        </Text>
      </Stack>
    </Stack>
  );
}
